import { useQuery } from "@tanstack/react-query";

import { coursesKeys } from "../../../../redux/services/coursesKey.services";

import { getCoursesApiCall } from "./utils.api";

export const useGetCourses = (params) =>
  useQuery({
    queryKey: coursesKeys.getCoursesKeys(params),
    queryFn: () => getCoursesApiCall(params),
  });
